<template>
  <main class="">
    <div
      class="tw-flex tw-justify-between tw-items-center tw-flex-wrap tw-gap-y-5 md:tw-gap-y-0"
    >
      <div class="">
        <h1 class="tw-mb-2 tw-text-xl tw-font-bold tw-text-[#1A2139]">
          All Members
        </h1>
        <p class="tw-text-[#4F5877] tw-text-sm tw-font-[450]">
          You have {{ convertToLocale(total) }} members
        </p>
      </div>
      <DealRoomInvite title="Add Member" />
    </div>
    <div class="tw-w-full tw-mt-7 tw-flex tw-items-center tw-flex-wrap">
      <Search
        type="name"
        :showSearchField="true"
        placeholder="Search members"
        @search-input="findMember"
      />
      <div class="tw-relative tw-w-24 tw-h-10">
        <div class="tw-flex tw-justify-end">
          <button
            class="tw-flex tw-rounded tw-bg-white tw-border tw-border-[#F1F3F6] tw-h-10 tw-w-24 tw-px-4 tw-py-3 tw-items-center tw-justify-center tw-gap-x-2 hover:tw-bg-white"
            @click="showFilter = !showFilter"
          >
            <img
              class="tw-h-4 tw-w-4"
              src="@/assets/img/filter.svg"
              alt="filter"
            />
            <span
              class="tw-hidden sm:tw-block tw-text-[#949DBC] tw-text-sm tw-tracking-[-0.12px]"
              >Filter</span
            >
          </button>
        </div>
        <FilterComponent
          v-show="showFilter"
          class="tw-right-0 tw-top-16 sm:tw-top-0 tw-mt-0"
          :class="{ 'tw-absolute': showFilter }"
          title="Filter Members"
          :options="filterOptions"
          @close="showFilter = !showFilter"
          @filter="filter"
        />
      </div>
      <exportToCsv
        class="tw-ml-8 md:tw-ml-auto"
        v-if="allDealRoomMembers && allDealRoomMembers.length !== 0"
        docType="Members"
        :fileName="organisationDetails.name"
        :data="allDealRoomMembers"
      />
    </div>
    <div class="table-container tw-mt-6">
      <MembersTable
        v-if="membersArray && membersArray.length !== 0"
        :tableHeaders="tableHeaders"
        :tableRows="tableRows"
        :columnNumber="tableHeaders.length - 2"
        :columnWidth="200"
        :totalPage="pages"
        :currentPage="page"
        :deals="privateTokens"
        @gotoPage="gotoPage"
        @update-members="fetchDealRoomMembers({ page, status })"
      />
      <EmptyState v-if="!membersArray || membersArray.length === 0">
        <template v-slot:message>
          <div class="tw-text-center tw-text-gray tw-my-3">
            <p>There are no members on this account.</p>
          </div>
        </template>
      </EmptyState>
    </div>
  </main>
</template>

<script>
  import DealRoomInvite from "@/components/privateRaise/DealRoomInvite";
  import { convertToLocale } from "@/utils/helpers";
  import { mapActions, mapGetters } from "vuex";
  import MembersTable from "@/components/tables/MembersTable";
  import EmptyState from "@/components/notification/EmptyState";
  import { formatISOTime, formatISODate, truncate } from "@/utils/helpers.js";
  import FilterComponent from "@/components/general/FilterComp";
  import Search from "@/components/general/Search";
  import search from "@/mixins/search";
  import exportToCsv from "@/components/general/exportToCSV";
  export default {
    name: "Memberss",
    data() {
      return {
        total: 0,
        tableHeaders: [
          "Name",
          "Email",
          "Phone Number",
          "Date Joined",
          "Status",
          "Action",
          "id",
        ],
        showFilter: false,
        filterOptions: [
          { name: "Active", value: "Active" },
          { name: "Deactivated", value: "Inactive" },
        ],
        tableRows: [],
        searchValue: "",
        page: 1,
        pages: 0,
        status: "",
        membersArray: "",
        memberName: "",
        allMembers: [],
      };
    },
    components: {
      MembersTable,
      EmptyState,
      DealRoomInvite,
      FilterComponent,
      Search,
      exportToCsv,
    },

    mixins: [search],
    computed: {
      ...mapGetters("TokenModule", [
        "dealroomMembers",
        "members",
        "allDealRoomMembers",
      ]),
      ...mapGetters("organisationModule", [
        "privateTokens",
        "organisationDetails",
      ]),
    },
    created() {
      this.getAllMembers();
      this.fetchDealRoomMembers();
      this.getTokens();
    },
    watch: {
      dealroomMembers(val) {
        this.membersArray = val;
      },
      members(val) {
        this.membersArray = val;
      },
      membersArray: "updateTableRow",
    },
    methods: {
      ...mapActions("TokenModule", [
        "getDealRoomMembers",
        "fetchMemberByName",
        "getWaitlistMembers",
        "getAllDealRoomMembers",
      ]),
      ...mapActions("organisationModule", ["getTokens"]),
      convertToLocale,
      async fetchDealRoomMembers(
        query = { page: 1, status: this.status || null, limit: 10 }
      ) {
        try {
          if (!query.status) {
            delete query.status;
          }
          if (query.status === "Waitlist") {
            this.fetchWaitlistMembers({ page: this.page });
            return;
          }
          const response = await Promise.all([
            this.getDealRoomMembers(query),
            this.getAllDealRoomMembers({ page: 1, limit: 100000 }),
          ]);
          const { page, pages, total } = response[0].data.data;
          this.total = total;
          this.page = page;
          this.pages = pages;
        } catch (error) {
          return error;
        }
      },
      async getAllMembers() {
        try {
          const response = await this.getDealRoomMembers({ page: 1 });
          const { data } = response.data;
          const allMembers = data.members;
          this.allMembers = allMembers;
        } catch (error) {
          return error;
        }
      },
      async fetchWaitlistMembers(query) {
        try {
          const response = await this.getWaitlistMembers(query);
          const { page, pages, total } = response.data.data;
          this.total = total;
          this.page = page;
          this.pages = pages;
        } catch (error) {
          return error;
        }
      },

      updateTableRow() {
        this.tableRows = this.membersArray?.map((member) => {
          let name = "";
          let status = member.status;
          switch (status) {
            case "Inactive":
              status = "Deactivated";
              break;

            case "Pending_Approval":
              status = "Pending";
              break;
            default:
              break;
          }
          if (status == "Pending") {
            name = member.name;
          } else {
            name = `${member.user ? member.user.fname : member.fname} ${
              member.user ? member.user.lname : member.lname
            }`;
          }
          return {
            name: `<span class="tw-font-medium">${name}</span>`,
            email: truncate(
              member.user?.email ? member.user?.email : member.email,
              25
            ),
            phone: `
            <a href="tel:+${member.user?.phone}">${
              member.user?.phone || "------"
            }</a>`,
            joined: `${formatISODate(
              member.createdAt || member.date_joined
            )}  ${formatISOTime(member.createdAt || member.date_joined)}`,
            id: `data-id/${member.member_id ? member.member_id : member._id}/${
              member.user ? member.user._id : member._id
            }`,
            status: status,
          };
        });
      },
      async findMember(obj) {
        const name = obj.value;
        this.memberName = name;
        if (name.length === 0) {
          this.fetchDealRoomMembers();
        } else {
          try {
            await this.fetchMemberByName(name);
          } catch (error) {
            return error;
          }
        }
      },

      filter(status) {
        this.status = status;
        let query = { page: 1, status };
        if (status === "Waitlist") {
          this.fetchWaitlistMembers({ page: 1 });
        } else {
          this.fetchDealRoomMembers(query);
        }
      },

      gotoPage(page) {
        const query = { page: page, status: this.status };
        this.fetchDealRoomMembers(query);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .table-container {
    overflow: auto;
  }
</style>
